import * as Cookies from 'js-cookie'
import random from 'lodash-es/random'
import { ThunkAction } from 'redux-thunk'

import experimentsIds from '../../common/constants/experiments'
import { IRootState } from '../../common/reducers'
import { hasFeature } from '../../common/utils/features'
import { reportExperimentEnrolment } from '../analytics/experimentsAnalytics'

export enum TypeKeys {
  EXPERIMENT_DATA_RECEIVED = 'experimentDataReceived',
  EXPERIMENTS_READY = 'experimentsReady',
  EXPERIMENTS_ERROR = 'fetchExperimentDataError'
}

interface IExperimentPayload {
  experiment_id: string
  variant: string
}

interface IExperimentDataReceivedAction {
  type: TypeKeys.EXPERIMENT_DATA_RECEIVED
  payload: IExperimentPayload
}

interface IExperimentsReadyAction {
  type: TypeKeys.EXPERIMENTS_READY
  payload: boolean
}

interface IExperimentsErrorAction {
  type: TypeKeys.EXPERIMENTS_ERROR
  payload: IExperimentPayload
}

export type ActionTypes =
  | IExperimentDataReceivedAction
  | IExperimentsReadyAction
  | IExperimentsErrorAction

export const experimentsReady = (): IExperimentsReadyAction => ({
  type: TypeKeys.EXPERIMENTS_READY,
  payload: true
})

export const getExperimentVariant = (
  experimentId: string
): IExperimentDataReceivedAction => {
  const experimentCookieKey = `experiment_${experimentId}`
  const experimentCookieValue = Cookies.get(experimentCookieKey)

  const experimentData: IExperimentPayload = {
    experiment_id: experimentId,
    variant: '0'
  }

  // if the experiment cookie exist, simply fetch it from cookie
  if (experimentCookieValue) {
    experimentData.variant = experimentCookieValue

    // otherwise generate a random variant and save it to cookie
  } else {
    // pick a random number between (0, 3)  0,1 are variant A.  2,3 are variant B
    const randomVariant = random(3).toString()
    experimentData.variant = randomVariant

    // save it local cookie
    Cookies.set(experimentCookieKey, randomVariant, {
      expires: 90, // 90 days
      path: '/'
    })
  }

  try {
    reportExperimentEnrolment({
      experimentId,
      variant: experimentData.variant
    })
  } finally {
    // eslint-disable-next-line
    return { type: TypeKeys.EXPERIMENT_DATA_RECEIVED, payload: experimentData }
  }
}

export const setExperiments = (): ThunkAction<
  IExperimentDataReceivedAction | IExperimentsReadyAction | null,
  IRootState,
  void
> => {
  return (dispatch, getState) => {
    const { currentSite } = getState().common
    const { location } = getState().router
    const { experiments } = getState()

    const categoryPageExperimentEnabled = hasFeature(
      'categoryPage:enrolment',
      currentSite,
      location,
      experiments
    )

    if (categoryPageExperimentEnabled) {
      dispatch(getExperimentVariant(experimentsIds.categoryPage))
    }

    return dispatch(experimentsReady())
  }
}
